if (!customElements.get('zen-back-to-top')) {
  customElements.define('zen-back-to-top',
    class ZenBackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.onScroll = this.onScroll.bind(this);
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.button.addEventListener('click', () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        if (window.scrollY > 500) {
          this.classList.add('is-visible');
        } else {
          this.classList.remove('is-visible');
        }
      }
    }
  );
}
